import api from 'Api'
import axios from 'axios'
import { SET_MESSAGE } from '../components/utils'
import { forwardMonth } from '../utils/main_helper'

import ENTERPRISE_RISK_DEMO from 'Demo/enterprise-risk.json'

import FIRST_LEVEL from 'Demo/treeMapFirst.json'
import SECOND_LEVEL from 'Demo/treeMapSecond.json'
import THIRD_LEVEL from 'Demo/treeMapThird.json'
const moment = require('moment')

const isDemoMode = process.env.VUE_APP_MODE === 'demo'

const URL_DATA_RISK = '/analytics/data-risk-detail-analysis'
const URL_DATA_RISK_UNSTRUCTURED_DEMO = '/demo/risk-overview-unstructured.json'
const URL_DATA_RISK_STRUCTURED_DEMO = '/demo/risk-overview-structured.json'

const URL_OVERVIEW_RISK = '/analytics/container'
const URL_ENTERPRISE_RISK = '/analytics/data-risk-trending'

const isTestingZoomMap = false // todo Temporary

const state = {
  macroMetrics: {},
  macroMetricsLoading: false,
  unStructured: true,
  riskOverviewDate: undefined,
  riskOverviewLoading: false,
  zoomTreeMapLoading: false,
  treeMapZoomLevels: [],
  riskOverviewData: {
    name: '',
    children: []
  },
  riskOverviewDataExcited: false,
  zoomTreeMap: {
    name: '',
    children: []
  },
  zoomableDetails: {
    clickedIdContainer: undefined,
    zoomLevel: 0,
    currentDirectory: undefined
  },
  organizationChanged: false,
  riskEnterpriseData: {},
  riskEnterpriseDateIndex: undefined,
  initialRiskEnterpriseData: {},
  riskEnterpriseLoading: true,
  riskEnterpriseDataUnstructured: {},
  queryScale: 1,
  overallRisk: {
    name: 'flare',
    children: [{
      name: 'analytics',
      total: '48716',
      children: [{
        name: 'cluster',
        children: [{ name: 'AgglomerativeCluster', value: 3938 }, {
          name: 'CommunityStructure',
          value: 3812
        }, { name: 'HierarchicalCluster', value: 6714 }, { name: 'MergeEdge', value: 743 }]
      }, {
        name: 'graph',
        children: [{ name: 'BetweennessCentrality', value: 3534 }, {
          name: 'LinkDistance',
          value: 5731
        }, { name: 'MaxFlowMinCut', value: 7840 }, { name: 'ShortestPaths', value: 5914 }, {
          name: 'SpanningTree',
          value: 3416
        }]
      }, { name: 'optimization', children: [{ name: 'AspectRatioBanker', value: 7074 }] }]
    }, {
      name: 'animate',
      total: '100024',
      children: [{ name: 'Easing', value: 17010 }, {
        name: 'FunctionSequence',
        value: 5842
      }, {
        name: 'interpolate',
        children: [{ name: 'ArrayInterpolator', value: 1983 }, {
          name: 'ColorInterpolator',
          value: 2047
        }, { name: 'DateInterpolator', value: 1375 }, {
          name: 'Interpolator',
          value: 8746
        }, { name: 'MatrixInterpolator', value: 2202 }, {
          name: 'NumberInterpolator',
          value: 1382
        }, { name: 'ObjectInterpolator', value: 1629 }, {
          name: 'PointInterpolator',
          value: 1675
        }, { name: 'RectangleInterpolator', value: 2042 }]
      }, { name: 'ISchedulable', value: 1041 }, { name: 'Parallel', value: 5176 }, {
        name: 'Pause',
        value: 449
      }, { name: 'Scheduler', value: 5593 }, { name: 'Sequence', value: 5534 }, {
        name: 'Transition',
        value: 9201
      }, { name: 'Transitioner', value: 19975 }, { name: 'TransitionEvent', value: 1116 }, {
        name: 'Tween',
        value: 6006
      }]
    }, {
      name: 'data',
      total: '30284',
      children: [{
        name: 'converters',
        children: [{ name: 'Converters', value: 721 }, {
          name: 'DelimitedTextConverter',
          value: 4294
        }, { name: 'GraphMLConverter', value: 9800 }, {
          name: 'IDataConverter',
          value: 1314
        }, { name: 'JSONConverter', value: 2220 }]
      }, { name: 'DataField', value: 1759 }, { name: 'DataSchema', value: 2165 }, {
        name: 'DataSet',
        value: 586
      }, { name: 'DataSource', value: 3331 }, { name: 'DataTable', value: 772 }, { name: 'DataUtil', value: 3322 }]
    }, {
      name: 'display',
      total: '24254',
      children: [{ name: 'DirtySprite', value: 8833 }, { name: 'LineSprite', value: 1732 }, {
        name: 'RectSprite',
        value: 3623
      }, { name: 'TextSprite', value: 10066 }]
    }, { name: 'flex', total: '4116', children: [{ name: 'FlareVis', value: 4116 }] }, {
      name: 'physics',
      total: '29934',
      children: [{ name: 'DragForce', value: 1082 }, { name: 'GravityForce', value: 1336 }, {
        name: 'IForce',
        value: 319
      }, { name: 'NBodyForce', value: 10498 }, { name: 'Particle', value: 2822 }, {
        name: 'Simulation',
        value: 9983
      }, { name: 'Spring', value: 2213 }, { name: 'SpringForce', value: 1681 }]
    }, {
      name: 'query',
      total: '89721',
      children: [{ name: 'AggregateExpression', value: 1616 }, { name: 'And', value: 1027 }, {
        name: 'Arithmetic',
        value: 3891
      }, { name: 'Average', value: 891 }, { name: 'BinaryExpression', value: 2893 }, {
        name: 'Comparison',
        value: 5103
      }, { name: 'CompositeExpression', value: 3677 }, { name: 'Count', value: 781 }, {
        name: 'DateUtil',
        value: 4141
      }, { name: 'Distinct', value: 933 }, { name: 'Expression', value: 5130 }, {
        name: 'ExpressionIterator',
        value: 3617
      }, { name: 'Fn', value: 3240 }, { name: 'If', value: 2732 }, { name: 'IsA', value: 2039 }, {
        name: 'Literal',
        value: 1214
      }, { name: 'Match', value: 3748 }, { name: 'Maximum', value: 843 }, {
        name: 'methods',
        children: [{ name: 'add', value: 593 }, { name: 'and', value: 330 }, {
          name: 'average',
          value: 287
        }, { name: 'count', value: 277 }, { name: 'distinct', value: 292 }, {
          name: 'div',
          value: 595
        }, { name: 'eq', value: 594 }, { name: 'fn', value: 460 }, { name: 'gt', value: 603 }, {
          name: 'gte',
          value: 625
        }, { name: 'iff', value: 748 }, { name: 'isa', value: 461 }, { name: 'lt', value: 597 }, {
          name: 'lte',
          value: 619
        }, { name: 'max', value: 283 }, { name: 'min', value: 283 }, { name: 'mod', value: 591 }, {
          name: 'mul',
          value: 603
        }, { name: 'neq', value: 599 }, { name: 'not', value: 386 }, { name: 'or', value: 323 }, {
          name: 'orderby',
          value: 307
        }, { name: 'range', value: 772 }, { name: 'select', value: 296 }, {
          name: 'stddev',
          value: 363
        }, { name: 'sub', value: 600 }, { name: 'sum', value: 280 }, {
          name: 'update',
          value: 307
        }, { name: 'variance', value: 335 }, { name: 'where', value: 299 }, {
          name: 'xor',
          value: 354
        }, { name: '_', value: 264 }]
      }, { name: 'Minimum', value: 843 }, { name: 'Not', value: 1554 }, {
        name: 'Or',
        value: 970
      }, { name: 'Query', value: 13896 }, { name: 'Range', value: 1594 }, {
        name: 'StringUtil',
        value: 4130
      }, { name: 'Sum', value: 791 }, { name: 'Variable', value: 1124 }, {
        name: 'Variance',
        value: 1876
      }, { name: 'Xor', value: 1101 }]
    }, {
      name: 'scale',
      total: '31294',
      children: [{ name: 'IScaleMap', value: 2105 }, { name: 'LinearScale', value: 1316 }, {
        name: 'LogScale',
        value: 3151
      }, { name: 'OrdinalScale', value: 3770 }, { name: 'QuantileScale', value: 2435 }, {
        name: 'QuantitativeScale',
        value: 4839
      }, { name: 'RootScale', value: 1756 }, { name: 'Scale', value: 4268 }, {
        name: 'ScaleType',
        value: 1821
      }, { name: 'TimeScale', value: 5833 }]
    }, {
      name: 'util',
      total: '165157',
      children: [{ name: 'Arrays', value: 8258 }, { name: 'Colors', value: 10001 }, {
        name: 'Dates',
        value: 8217
      }, { name: 'Displays', value: 12555 }, { name: 'Filter', value: 2324 }, {
        name: 'Geometry',
        value: 10993
      }, {
        name: 'heap',
        children: [{ name: 'FibonacciHeap', value: 9354 }, { name: 'HeapNode', value: 1233 }]
      }, { name: 'IEvaluable', value: 335 }, { name: 'IPredicate', value: 383 }, {
        name: 'IValueProxy',
        value: 874
      }, {
        name: 'math',
        children: [{ name: 'DenseMatrix', value: 3165 }, { name: 'IMatrix', value: 2815 }, {
          name: 'SparseMatrix',
          value: 3366
        }]
      }, { name: 'Maths', value: 17705 }, { name: 'Orientation', value: 1486 }, {
        name: 'palette',
        children: [{ name: 'ColorPalette', value: 6367 }, { name: 'Palette', value: 1229 }, {
          name: 'ShapePalette',
          value: 2059
        }, { name: 'SizePalette', value: 2291 }]
      }, { name: 'Property', value: 5559 }, { name: 'Shapes', value: 19118 }, {
        name: 'Sort',
        value: 6887
      }, { name: 'Stats', value: 6557 }, { name: 'Strings', value: 22026 }]
    }, {
      name: 'vis',
      total: '432629',
      children: [{
        name: 'axis',
        children: [{ name: 'Axes', value: 1302 }, { name: 'Axis', value: 24593 }, {
          name: 'AxisGridLine',
          value: 652
        }, { name: 'AxisLabel', value: 636 }, { name: 'CartesianAxes', value: 6703 }]
      }, {
        name: 'controls',
        children: [{ name: 'AnchorControl', value: 2138 }, {
          name: 'ClickControl',
          value: 3824
        }, { name: 'Control', value: 1353 }, { name: 'ControlList', value: 4665 }, {
          name: 'DragControl',
          value: 2649
        }, { name: 'ExpandControl', value: 2832 }, { name: 'HoverControl', value: 4896 }, {
          name: 'IControl',
          value: 763
        }, { name: 'PanZoomControl', value: 5222 }, {
          name: 'SelectionControl',
          value: 7862
        }, { name: 'TooltipControl', value: 8435 }]
      }, {
        name: 'data',
        children: [{ name: 'Data', value: 20544 }, { name: 'DataList', value: 19788 }, {
          name: 'DataSprite',
          value: 10349
        }, { name: 'EdgeSprite', value: 3301 }, { name: 'NodeSprite', value: 19382 }, {
          name: 'render',
          children: [{ name: 'ArrowType', value: 698 }, { name: 'EdgeRenderer', value: 5569 }, {
            name: 'IRenderer',
            value: 353
          }, { name: 'ShapeRenderer', value: 2247 }]
        }, { name: 'ScaleBinding', value: 11275 }, { name: 'Tree', value: 7147 }, {
          name: 'TreeBuilder',
          value: 9930
        }]
      }, {
        name: 'events',
        children: [{ name: 'DataEvent', value: 2313 }, {
          name: 'SelectionEvent',
          value: 1880
        }, { name: 'TooltipEvent', value: 1701 }, { name: 'VisualizationEvent', value: 1117 }]
      }, {
        name: 'legend',
        children: [{ name: 'Legend', value: 20859 }, { name: 'LegendItem', value: 4614 }, {
          name: 'LegendRange',
          value: 10530
        }]
      }, {
        name: 'operator',
        children: [{
          name: 'distortion',
          children: [{ name: 'BifocalDistortion', value: 4461 }, {
            name: 'Distortion',
            value: 6314
          }, { name: 'FisheyeDistortion', value: 3444 }]
        }, {
          name: 'encoder',
          children: [{ name: 'ColorEncoder', value: 3179 }, {
            name: 'Encoder',
            value: 4060
          }, { name: 'PropertyEncoder', value: 4138 }, { name: 'ShapeEncoder', value: 1690 }, {
            name: 'SizeEncoder',
            value: 1830
          }]
        }, {
          name: 'filter',
          children: [{ name: 'FisheyeTreeFilter', value: 5219 }, {
            name: 'GraphDistanceFilter',
            value: 3165
          }, { name: 'VisibilityFilter', value: 3509 }]
        }, { name: 'IOperator', value: 1286 }, {
          name: 'label',
          children: [{ name: 'Labeler', value: 9956 }, {
            name: 'RadialLabeler',
            value: 3899
          }, { name: 'StackedAreaLabeler', value: 3202 }]
        }, {
          name: 'layout',
          children: [{ name: 'AxisLayout', value: 6725 }, {
            name: 'BundledEdgeRouter',
            value: 3727
          }, { name: 'CircleLayout', value: 9317 }, {
            name: 'CirclePackingLayout',
            value: 12003
          }, { name: 'DendrogramLayout', value: 4853 }, {
            name: 'ForceDirectedLayout',
            value: 8411
          }, { name: 'IcicleTreeLayout', value: 4864 }, {
            name: 'IndentedTreeLayout',
            value: 3174
          }, { name: 'Layout', value: 7881 }, { name: 'NodeLinkTreeLayout', value: 12870 }, {
            name: 'PieLayout',
            value: 2728
          }, { name: 'RadialTreeLayout', value: 12348 }, {
            name: 'RandomLayout',
            value: 870
          }, { name: 'StackedAreaLayout', value: 9121 }, { name: 'TreeMapLayout', value: 9191 }]
        }, { name: 'Operator', value: 2490 }, { name: 'OperatorList', value: 5248 }, {
          name: 'OperatorSequence',
          value: 4190
        }, { name: 'OperatorSwitch', value: 2581 }, { name: 'SortOperator', value: 2023 }]
      }, { name: 'Visualization', value: 16540 }]
    }]
  }
}

const getters = {
  getDst: state => {
    return state.unStructured ? 'US' : 'S'
  },
  getRisks: state => {
    const risks = state.riskOverviewData && state.riskOverviewData.children.map(item => item.data_risk_aggregation)
    return risks && risks.filter((a, b) => risks.indexOf(a) === b)
  },
  getTotalVolumes: state => {
    return state.riskOverviewData && state.riskOverviewData.children.map(item => item.total_volume)
  },
  canViewData: (state, getters, rootState, rootGetters) => {
    return rootGetters.currentOrganization?.can_view_data ?? true
  }
}

const actions = {
  async loadEnterpriseRiskData ({ rootState, getters, commit }, payload) {
    const organizationId = payload?.organization_id ? payload.organization_id : rootState.currentOrganization.entity_id

    /**
     * If current organization can't view the data, or current organization is not set
     */
    if (!getters.canViewData || !organizationId) {
      commit('SET_ENTERPRISE_RISK', [])
      return
    }

    commit('SET_ENTERPRISE_RISK_LOADING', true)
    commit('SET_COST_PER_RECORD')
    let response
    try {
      if (!isDemoMode) {
        response = await api().get(`${URL_ENTERPRISE_RISK}?organization_id=${organizationId}`)
      } else response = { data: ENTERPRISE_RISK_DEMO }
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
      commit('SET_ENTERPRISE_RISK_LOADING', false)
      return
    }
    commit('SET_ENTERPRISE_RISK_LOADING', false)
    commit('SET_ENTERPRISE_RISK', !isDemoMode ? response.data : forwardMonth(response.data))
    commit('SET_ENTERPRISE_RISK_UNSTRUCTURED', !isDemoMode ? response.data : forwardMonth(response.data))
    return response
  },
  async loadOverviewRiskData (context, payload) {
    const organizationId = payload?.organization_id ? payload.organization_id : context.rootState.currentOrganization.entity_id

    /**
     * If current organization can't view the data, or current organization is not set
     */
    if (!context.getters.canViewData || !organizationId) {
      context.commit('SET_OVERVIEW_RISK', [])
      return
    }

    /**
     * If the month is further back than the current month minus the months_of_data value,
     * then the treemap will display a placeholder
     */
    const currentMonth = Number(moment().month())
    const monthToFetch = Number(moment(payload?.date).format('M'))
    const monthsOfData = context.rootState.organizationStore.activeOrganization?.months_of_data
    if (monthsOfData && (monthToFetch < currentMonth - monthsOfData)) {
      context.commit('SET_OVERVIEW_RISK_EXCITED', true)
      return
    } else context.commit('SET_OVERVIEW_RISK_EXCITED', false)

    let currentTime
    if (payload?.date) {
      currentTime = payload.date
    } else {
      const moments = context.state.riskEnterpriseData?.date?.map(d => moment(d, 'YYYY-MM-DD'))
      currentTime = moments && moment(moment.max(moments)._i, 'YYYY-MM-DD').format('YYYY-MM-DD')
    }

    if (!currentTime) {
      context.commit('SET_OVERVIEW_RISK', [])
      return
    }

    context.commit('SET_OVERVIEW_RISK_LOADING', true)
    context.commit('SET_ENTERPRISE_RISK_DATE', currentTime)
    let response
    try {
      if (!isDemoMode) {
        response = await api().get(`${URL_DATA_RISK}?organization_id=${organizationId}&month=${moment(currentTime, 'YYYY-MM-DD').format('MM/YYYY')}&dst=${context.getters.getDst}`)
      } else {
        const currentData = context.getters.getDst === 'US' ? await axios.get(URL_DATA_RISK_UNSTRUCTURED_DEMO) : await axios.get(URL_DATA_RISK_STRUCTURED_DEMO)
        if (currentTime) {
          currentData.data = currentData.data.filter(item => item.month === (+currentTime.split('-')[1]).toString())
        }
        response = currentData
      }
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: e || 'Error' })
      context.commit('SET_OVERVIEW_RISK_LOADING', false)
      return
    }
    context.commit('SET_OVERVIEW_RISK_LOADING', false)
    context.commit('SET_OVERVIEW_RISK', response.data || [])
    return response
  },
  async loadZoomTreeMapData (context, payload) {
    const organizationId = payload?.organization_id ? payload.organization_id : context.rootState.currentOrganization.entity_id
    /**
     * If current organization can't view the data, or current organization is not set
     */
    if (!context.getters.canViewData || !organizationId) {
      context.commit('SET_OVERVIEW_RISK', [])
      return
    }

    context.commit('SET_ZOOM_TREE_MAP_LOADING', true)
    if (!organizationId) {
      context.commit('SET_ZOOM_TREE_MAP', [])
      return
    }
    const moments = context.state.riskEnterpriseData?.date?.map(d => moment(d, 'YYYY-MM-DD'))
    const currentTime = moments && moment(moment.max(moments)._i, 'YYYY-MM-DD').format('YYYY-MM-DD')
    // if (!currentTime) {
    //   context.commit('SET_OVERVIEW_RISK', [])
    //   context.commit('SET_ZOOM_TREE_MAP', [])
    //   context.commit('SET_UNSTRUCTURED', true)
    //   context.commit('SET_ENTERPRISE_RISK_DATE', currentTime)
    //   context.commit('SET_ZOOM_TREE_MAP_LOADING', false)
    //   return
    // }
    let response
    try {
      if (!isDemoMode) {
        if (currentTime) {
          const month = currentTime?.split('-')[1].toString()
          const year = currentTime?.split('-')[0].toString()
          response = await api().get(`${URL_OVERVIEW_RISK}?organization_id=${organizationId}&month=${month}&year=${year}&data_structure_type=${context.getters.getDst}`)
        } else {
          response = await api().get(`${URL_OVERVIEW_RISK}?organization_id=${organizationId}&data_structure_type=${context.getters.getDst}`)
        }
      } else {
        response = { data: FIRST_LEVEL }
      }
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
      context.commit('SET_ZOOM_TREE_MAP_LOADING', false)
      return
    }
    context.commit('SET_ZOOM_TREE_MAP', response.data)
    context.commit('SET_ZOOM_TREE_MAP_LOADING', false)
    return response
  },

  async getTreeMapChildren (context, payload) {
    const organizationId = payload?.organization_id || context.rootState.currentOrganization.entity_id
    if (!isDemoMode) {
      if (payload.isRoot) { // todo need to detect if we need isRoot property
        return await api().get(`${URL_OVERVIEW_RISK}?organization_id=${organizationId}&data_structure_type=${payload.data_structure_type}`)
      } else {
        return await api().get(`${URL_OVERVIEW_RISK}?organization_id=${organizationId}&container_id=${payload.containerId}&month=${payload.month}&year=${payload.year}&data_structure_type=${payload.data_structure_type}`)
      }
    } else {
      const currentData = (
        (payload.level === 0 && FIRST_LEVEL) ||
        (payload.level === 1 && SECOND_LEVEL) ||
        (payload.level === 2 && THIRD_LEVEL)
      )
      return {
        data: currentData
      }
    }
  }
}

const mutations = {
  SET_ZOOM_TREE_MAP_LOADING (state, payload) {
    state.zoomTreeMapLoading = payload
  },
  SET_ZOOM_TREE_MAP (state, payload) {
    if (Array.isArray(payload)) {
      state.zoomTreeMap = {
        name: '',
        children: payload
      }
    } else {
      state.zoomTreeMap = {
        name: payload.name,
        children: payload.children
      }
    }
  },
  SET_TREE_MAP_LEVEL (state, payload) {
    if (payload.push) {
      state.treeMapZoomLevels.push(payload.data)
    } else {
      const findIndex = state.treeMapZoomLevels.findIndex(e => e.id === payload.cutId)
      if (findIndex > -1) {
        state.treeMapZoomLevels.splice(findIndex, 1)
      }
    }
  },
  SET_TREEMAP_DETAIL (state, { key, value }) {
    const newObj = state.zoomableDetails
    newObj[key] = value
    state.zoomableDetails = newObj
  },
  SET_UNSTRUCTURED (state, unStructured) {
    state.unStructured = unStructured
  },
  SET_OVERVIEW_RISK (state, payload) {
    if (Array.isArray(payload) && !payload.length) {
      state.riskOverviewData = payload
      return
    }
    if (!isTestingZoomMap) { // temporary testing
      // * Reducing Unstructured data (Temporary)
      if (state.unStructured) {
        payload.length = 225
      }
      payload.forEach(i => {
        i.children = [{
          application_name: true,
          collection_id: '788',
          collection_name: 'product_chain',
          container_id: '56',
          container_name: 'admin_prim',
          data_risk_aggregation: '408649',
          elements: '16',
          records: '2187217',
          size: true,
          total_volume: '42851482'
        }]
      })
    }
    if (Object.prototype.hasOwnProperty.call(payload, 'children')) {
      state.riskOverviewData = payload
    } else state.riskOverviewData.children = payload
  },
  SET_OVERVIEW_RISK_LOADING (state, loading) {
    state.riskOverviewLoading = loading
  },
  SET_OVERVIEW_RISK_EXCITED (state, bool) {
    state.riskOverviewDataExcited = bool
  },
  SET_COST_PER_RECORD (state) {
    state.organizationChanged = !state.organizationChanged
  },
  SET_ENTERPRISE_RISK (state, payload) {
    if (!payload) {
      state.riskEnterpriseData = {}
      return
    }
    state.riskEnterpriseData = {}
    if (Array.isArray(payload) && !payload.length) {
      state.initialRiskEnterpriseData = {}
      return
    }
    state.riskEnterpriseData.date = []
    for (let i = 0; i < payload.length; i++) {
      state.riskEnterpriseData.date.push(`${payload[i].year}-${payload[i].month}-01`)
      for (const key in payload[i]) {
        if (Object.prototype.hasOwnProperty.call(payload[i], key)) {
          if (!Object.prototype.hasOwnProperty.call(state.riskEnterpriseData, key)) {
            state.riskEnterpriseData[key] = []
          }
          state.riskEnterpriseData[key].push(payload[i][key])
        }
      }
    }
    state.initialRiskEnterpriseData = JSON.parse(JSON.stringify(state.riskEnterpriseData))
  },

  SET_ENTERPRISE_RISK_BY_COST (state, { min, max, avg, cyberDiscount }) {
    const data = JSON.parse(JSON.stringify(state.initialRiskEnterpriseData))
    if (!data || !data.data_risk_min) {
      return
    }

    if (!Object.keys(state.riskEnterpriseData).length) return
    const length = data?.data_risk_min?.length
    for (let i = 0; i < length; i++) {
      data.data_risk_min.splice(i, 1, parseFloat(min) * parseFloat(data.resolved_identities[i]) * (1 - parseFloat(cyberDiscount)))
      data.data_risk_max.splice(i, 1, parseFloat(max) * parseFloat(data.resolved_identities[i]) * (1 - parseFloat(cyberDiscount)))
      data.data_risk_avg.splice(i, 1, parseFloat(avg) * parseFloat(data.resolved_identities[i]) * (1 - parseFloat(cyberDiscount)))
    }
    state.riskEnterpriseData = { ...data }
  },
  SET_ENTERPRISE_RISK_UNSTRUCTURED (state, riskEnterpriseDataUnstructured) {
    state.riskEnterpriseDataUnstructured = riskEnterpriseDataUnstructured
  },
  SET_ENTERPRISE_RISK_DATE (state, date) {
    state.riskOverviewDate = date
  },
  SET_ENTERPRISE_RISK_LOADING (state, loading) {
    state.riskEnterpriseLoading = loading
  },
  SET_QUERY_SCALE (state, payload) {
    state.queryScale = payload
  },
  SET_RISK_ENTERPRISE_DATE_INDEX (state, index) {
    state.riskEnterpriseDateIndex = index
  },
  RESET_ENTERPRISE_RISK (state) {
    state.riskEnterpriseData = {}
    state.zoomTreeMap = { name: '', children: [] }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  name: 'dashboardServices'
}
